import React, { useState,useEffect } from 'react';
import { Layout, Menu, Button, Avatar, Dropdown } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import { AutoComplete, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { gql, useLazyQuery } from '@apollo/client'; // Apollo hooks for GraphQL query

import '../styles/SiteHeader.css';


const { Header } = Layout;

// GraphQL query to search for articles
const SEARCH_ARTICLES_QUERY = gql`
  query listArticles($query: String!) {
    listArticles(where: { title: { contains: $query } }) {
    id
    title
    createdAt
  }
  }
`;


const SiteHeader = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Simulate login state
  const [userName, setUserName] = useState(""); // Simulate login state
  const [options, setOptions] = useState([]); // For search suggestions
  const navigate = useNavigate(); // To navigate to article details
  const [roleType, setRoleType] = useState('');

  // Check login status on component mount
  useEffect(() => {
    const storedRole = localStorage.getItem('roleType');
    const userName = localStorage.getItem('userName');
    console.log(storedRole);
    if (storedRole!=null) {
      setIsLoggedIn(true);
      setRoleType(storedRole);
      setUserName(userName);
    } else {
      setIsLoggedIn(false);
      navigate('/'); // Redirect if not logged in
    }
  }, []);

  // Apollo lazy query hook to search articles
  const [searchArticles, { loading }] = useLazyQuery(SEARCH_ARTICLES_QUERY, {
    onCompleted: (data) => {
      // Map search results to AutoComplete options
      const searchResults = data.listArticles.map((article) => ({
        //value: article.id,
        label: (
          <div>
            <strong>{article.title}</strong> <br />
            <small>{new Date(article.createdAt).toLocaleDateString()}</small>
          </div>
        ),
      }));
      setOptions(searchResults);
    },
    onError: (error) => {
      console.error('Error fetching search results:', error);
      message.error('Failed to fetch articles');
    },
  });

  // Function to handle search input change
  const onSearch = (value) => {
    if (value) {
      searchArticles({ variables: { query: value } }); // Execute GraphQL query with user input
    } else {
      setOptions([]); // Clear suggestions if input is empty
    }
  };

 
  const loginUser = ()=>{
    navigate('/login');
  };
  const registerUser = ()=>{
    navigate('/register');
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem('roleType');
    localStorage.removeItem('userName');
    localStorage.removeItem('connectedInHmi');
    localStorage.clear();
   // navigate('/');
    if (window.location.pathname === '/') {
      window.location.reload();
    }
    // Add your logout logic here
  };
  const handleProfile = ()=>{
    navigate('/admin/home');
  };

  const userMenu = (
    <Menu>
      <Menu.Item key="profile" onClick={handleProfile}>Profile</Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className="header">
      <div className="logo" onClick={() => navigate('/')} style={{ cursor: 'pointer' }}> 
        <img src="/logo.png" alt="Tumbas Logo" className='logo-img' />
       
      </div>
     
      
      <div className="actions">
        {isLoggedIn ? (
          <Dropdown overlay={userMenu} trigger={['click']}>
            <div className="user-info">
              <Avatar icon={<UserOutlined />} />
              <span className="username">{userName}</span>
              <DownOutlined />
            </div>
          </Dropdown>
        ) : (
          <>
            <Button className="login-btn" onClick={()=>loginUser()}>Log In</Button>
            <Button type="primary" className="register-btn" onClick={()=>registerUser()}> Register</Button>
          </>
        )}
      </div>
    </Header>
  );
};

export default SiteHeader;
